import QueueRoutesAPI from 'dashboard/api/asterisk/queueRoutes';
import { createHandleRealtimeEvent } from './_helpers/asteriskRealtime';
import { createPendingOp } from './_helpers/asteriskAsyncOp';

const RESOURCE = 'queue_route';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id =>
    $state.records.find(r => r.id === id || r.id === Number(id)),
  getByShortcode: $state => shortcode =>
    $state.records.find(r => r.shortcode === shortcode),
};

export const actions = {
  // Recebe broadcast ActionCable disparado pelo ApiCallJob (QueueRoutesService)
  // e resolve a Promise pendente do create/update/delete via resolvePendingOp.
  handleRealtimeEvent: createHandleRealtimeEvent('fetch', RESOURCE),

  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await QueueRoutesAPI.get();
      const routes = response.data.data || response.data.queue_routes || [];
      commit('SET_RECORDS', routes);
      return routes;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const response = await QueueRoutesAPI.show(id);
    return response.data.data || response.data.queue_route || response.data;
  },

  // Backend retorna 202 (job enfileirado). Promise resolve quando broadcast
  // `asterisk.queue_route.changed` confirma — permite toast.promise no form.
  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      await QueueRoutesAPI.create(data);
      await createPendingOp(RESOURCE, 'created', null);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await QueueRoutesAPI.update(id, data);
      await createPendingOp(RESOURCE, 'updated', id);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await QueueRoutesAPI.delete(id);
      await createPendingOp(RESOURCE, 'deleted', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  ADD_RECORD($state, record) {
    $state.records.push(record);
  },

  UPDATE_RECORD($state, { id, data }) {
    const index = $state.records.findIndex(
      r => r.id === id || r.id === Number(id)
    );
    if (index !== -1) {
      $state.records[index] = { ...$state.records[index], ...data };
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(
      r => r.id !== id && r.id !== Number(id)
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
